export default "/images/bef2123b3822db12415853f611ace121.avif";